export default __webpack_public_path__ + "static/159-1d696ecf642fdf5bb458768aa695b633.jpg";